import { Outlet } from 'react-router-dom';

export default function PaymentLayout() {
  return <Outlet />;
}
